/* eslint-disable no-else-return */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Dialogs, Flex, Text, Pane, Toast, Content, Button } from '@leverege/ui-elements'
import { Config } from '@leverege/plugin'
import { TitleBar } from '@leverege/ui-plugin'
import I18N from '@leverege/i18n'
import { GlobalState, UI } from '@leverege/ui-redux'
import { isCompanyIntegrationDataStaleOrPending, INTEGRATION_STATUS } from '../../utils/IntegrationsUtils.js'
import OrganizationSelectionScreen from './OrganizationSelectionScreen.jsx'
import ResyncInventoryCard from './components/ResyncInventoryCard.jsx'
// import axios from 'axios'

const screenIcon = 'https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Screen%20Icons/screen-integrations-blue.svg'
const deereIcon = 'https://storage.googleapis.com/prd-generic-kudelski-ui-assets/DeereAgIntegrationsLogo.svg'

const { t } = I18N.ns( 'molten.screens.account.IntegrationsScreen' )

export function IntegrationsScreen( props ) {

  const { auth, parentItem } = props
  const userId = auth.profile.id
  const systemId = parentItem.data.systemId
  const companyId = parentItem.id
  const clientHost = `${window.location.protocol}//${window.location.host}` 
  const integrationStatusKey = `deere/company/${companyId}/integrationData`
  const orgSelectionStatusKey = `deere/company/${companyId}/isShowingOrgSelection`

  const [ integrationStatus, setIntegrationStatus ] = useState( INTEGRATION_STATUS.NOT_INTEGRATED )
  const [ buttonDisabled, setButtonDisabled ] = useState( true )
  const [ orgName, setOrgName ] = useState( null )

  const loadIntegrationStatus = () => {
    GlobalState.dispatch( async ( dispatch, getState, { api } ) => {
      try {
        const company = GlobalState.get().models.lookup?.[companyId]
        const isShowingOrgSelection = UI.get( getState(), orgSelectionStatusKey )
        const companyIntegrationData = UI.get( getState(), integrationStatusKey )
        
        let newIntegrationStatus = companyIntegrationData?.integrationStatus, orgsToSelect = [], orgName = companyIntegrationData?.orgName
        if ( isCompanyIntegrationDataStaleOrPending( companyIntegrationData ) ) {
          const res = await api.interface( systemId, 'company' )
            .obj( companyId )
            .srv( 'deere' )
            .get( 'integrationStatus' )
          newIntegrationStatus = res.integrationStatus
          orgsToSelect = res.orgsToSelect
          orgName = res?.orgName
        }
                
        await dispatch( UI.set( integrationStatusKey, { orgName, integrationStatus : newIntegrationStatus, timestamp : Date.now() } ) )
        setButtonDisabled( false )
        setIntegrationStatus( newIntegrationStatus )
        setOrgName( orgName )
        
        // Show selection
        if ( orgsToSelect?.length && !isShowingOrgSelection ) {
          await dispatch( UI.set( orgSelectionStatusKey, { isShowingOrgSelection : true } ) )          
          const orgNameAndIdList = orgsToSelect.map( ( orgData ) => { 
            const { id : orgId, name : orgName } = orgData
            return { name : orgName, value : orgId }
          } )
          Dialogs.show( {
            component : OrganizationSelectionScreen,
            props : { orgNameAndIdList, company }
          } )
        }

      } catch ( error ) {
        setButtonDisabled( true )
        Toast.error( 'Error loading integration status' )
        console.log( { message : 'IntegrationStatus.handleOrgSelection() - Fetch integration status error', err : error } )
      }
    } )
  }

  const startIntegration = async () => {
    await GlobalState.dispatch( async ( dispatch, getState, { api } ) => {
      try {
        const res = await api.interface( systemId, 'company' )
          .obj( companyId )
          .srv( 'deere' )
          .get( 'authEndpoint', { userId, clientHost } )

        const authEndpoint = res.authEndpoint
        await dispatch( UI.set( integrationStatusKey, null ) )
        window.location.href = authEndpoint

      } catch ( error ) {
        console.log( { msg : 'IntegrationsScreen.startIntegration() - Error getting auth endpoint', err : error } )
        Toast.error( 'Error initiating integration' )
      }
    } )    
  }

  const disableIntegration = async () => {
    await GlobalState.dispatch( async ( dispatch, getState, { api } ) => {
      try {
        await api.interface( systemId, 'company' ).obj( companyId ).srv( 'deere' ).patch( 'removeIntegration' )
        await dispatch( UI.set( integrationStatusKey, { integrationStatus : INTEGRATION_STATUS.NOT_INTEGRATED, timestamp : Date.now() } ) )
        setIntegrationStatus( INTEGRATION_STATUS.NOT_INTEGRATED )
        
      } catch ( error ) {
        console.log( { message : 'IntegrationsScreen.disableIntegration() - Error', err : error } )
        Toast.error( 'Error disabling integration' )
      }
    } )
  }

  const onButtonClick = async () => {    
    if ( integrationStatus === INTEGRATION_STATUS.NOT_INTEGRATED ) {
      await startIntegration()
    } else if ( integrationStatus === INTEGRATION_STATUS.INTEGRATED ) {
      await disableIntegration()
    } else {
      Toast.error( `Integration in improper state: ${integrationStatus}` )
    }
  }

  useEffect( () => {
    loadIntegrationStatus()
  } )

  const isIntegrated = integrationStatus === INTEGRATION_STATUS.INTEGRATED 
  const pillVariant = isIntegrated ? 'pillActive' : 'pillInactive'
  const pillText = isIntegrated ? 'Active' : 'Inactive'  
  const buttonText = isIntegrated ? 'Remove Connection' : 'Connect'
  const buttonVariant = isIntegrated ? 'secondaryDestructive' : 'primary'

  return ( 
    <Content>
      <Content.Header>
        <TitleBar 
          variant="screenTitle" 
          title="Integrations"
          icon={Config.get( 'IntegrationsScreen', 'screenIcon', screenIcon )}/>
      </Content.Header>
      <Content.Area variant="screenContent">
        <Pane variant="card" style={{ width : '600px', padding : '16px' }}>
          <Content relative>
            <Content.Header>
              <Flex variant="colM">
                <Flex variant="row" justify="space-between">
                  <img src={deereIcon} alt="John Deere Logo" style={{ height : '32px', width : '166px' }}/>
                  <Text variant={pillVariant} style={{ fontWeight : 'bold' }}>
                    {pillText}
                  </Text>
                </Flex>
                <Text variant="title" style={{ paddingTop : '8px' }} > John Deere Operations Center </Text>  
              </Flex>
            </Content.Header>
          
          {!isIntegrated && (
            <Content.Area variant="detailContent" style={{ paddingBottom : '16px', paddingTop : '16px' }}>
            
              <Text variant="detailLabel"> 
                John Deere Operations Center links you to your fleet and to your partners. It provides tools to help you set up, plan, monitor and analyze your work. Make data-informed decisions quickly, see what is happening now, and make better decisions on the next project or in the next season.
              </Text>
            </Content.Area>
          )}
            <Content.Footer variant="detailFooter">
              { isIntegrated ?
               ( 
                <>
                  <Text style={{ color : 'gray', paddingBottom : '8px', paddingTop: '8px' }}> 
                    Connected Organization: <b>{orgName}</b>
                  </Text> 
                  <ResyncInventoryCard {...props} />
                </>
              )
                : null
              }                                           
              <Button disabled={buttonDisabled} style={{ width : '100%' }} variant={buttonVariant} onClick={onButtonClick} >
                {buttonText}
              </Button>
            </Content.Footer>

          </Content>
        </Pane>
      </Content.Area>
    </Content>
  )
}

export default connect(
  state => ( {
    auth : state.auth,
    users : state.users
  } )
)( IntegrationsScreen )
